/**
 * @generated SignedSource<<d709b2e4632f8384516f6a6beb3e3628>>
 * @relayHash 0d86d9514ed0dc62ec55c47550347432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ForgeModalDeprecationMessage_appQuery$variables = {
  id: string;
};
export type ForgeModalDeprecationMessage_appQuery$data = {
  readonly app: {
    readonly name: string;
  } | null | undefined;
};
export type ForgeModalDeprecationMessage_appQuery = {
  response: ForgeModalDeprecationMessage_appQuery$data;
  variables: ForgeModalDeprecationMessage_appQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ForgeModalDeprecationMessage_appQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgeModalDeprecationMessage_appQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855",
    "metadata": {},
    "name": "ForgeModalDeprecationMessage_appQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6249f13b9dc8b658b8478b0412f6a152";

export default node;
